<template>
  <div class="activity-view">
    <ActivityList :actions-to-hide-details-button="['reserved', 'lotted', 'unlotted', 'unreserved', 'approved']"
                  :actions="actions"
                  :for="'inventory'"
                  :value-visualizer="valueVisualizer">
      <template v-slot:text="{activity}">
        {{ actions[activity.action] ? actions[activity.action].message : activity.action }}
      </template>
    </ActivityList>
  </div>
</template>

<script>
  import ActivityList from "../../../activities/ActivityList";
  import {createNamespacedHelpers} from "vuex";
  import inventoryActivityHelper from "@/modules/inventory/view/activities/inventoryActivityHelper";

  const {mapState} = createNamespacedHelpers('inventory');
  const {mapActions: activityMapActions} = createNamespacedHelpers('activities');
  const {mapState: mapStateBranch} = createNamespacedHelpers('setup/branch');
  const {mapState: mapStateDepartment} = createNamespacedHelpers('setup/department');


  export default {
    name: "ActivitiesView",
    components: {ActivityList},
    data: () => {
      return {
        actions: inventoryActivityHelper.actions
      };
    },
    computed: {
      ...mapState({
        inventory: state => state.view.currentInventory,
        ...mapStateBranch(['branches']),
        ...mapStateDepartment(['departments']),
      })
    },
    methods: {
      ...activityMapActions(['setActivitiesParams']),
      valueVisualizer: inventoryActivityHelper.valueVisualizer
    },
    beforeMount() {
      this.setActivitiesParams({object: this.inventory, source: 'inventory'})
    }
  }
</script>

<style lang="scss">

</style>
